module.exports = __webpack_public_path__ + "static/media/reference-slider.6bd675c3.jpg";